var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoPerfil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "on7jft2nsa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.29 30c-6.095 0-10.622-2.021-11.655-2.604-.101-.507-.146-1.388-.133-1.958 0-.05.006-.101.006-.158.045-1.445.21-3.023 1.686-3.549 3.155-.81 5.677-2.572 5.785-2.642M16.492 30c6.094 0 10.24-2.021 11.273-2.604.101-.507.146-1.388.133-1.958 0-.05-.006-.101-.006-.158-.045-1.445-.21-3.023-1.686-3.549-3.155-.81-5.677-2.572-5.784-2.642m-4.729-2.463h.168c1.534-.026 2.775-.565 3.692-1.597 2.016-2.273 1.681-6.169 1.644-6.54-.13-2.792-1.45-4.127-2.54-4.75-.811-.467-1.76-.718-2.817-.739h-.089c-.581 0-1.723.094-2.817.718-1.1.623-2.44 1.958-2.572 4.77-.036.372-.371 4.268 1.645 6.541.91 1.032 2.152 1.571 3.686 1.597z",
    stroke: "#00A9FD",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPerfil);
export default __webpack_public_path__ + "static/media/PictoPerfil.bc11f18c9fdf25acb07eccc618d4a9ce.svg";
export { ForwardRef as ReactComponent };